<!-- FmcsaChecklistItem.vue -->
<template>
  <div class="checklist-item d-flex align-items-center mb-2">
    <i class="fas fa-check-circle text-success mr-2" />
    <div>
      <div class="text-muted small">{{ label }}</div>
      <div class="font-weight-bold">{{ valueDisplay }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    value: [String, Number, Boolean]
  },
  computed: {
    valueDisplay() {
      if (this.value === 'Y') return 'Yes';
      if (this.value === 'N') return 'No';
      if (this.value === null || this.value === undefined || this.value === '') return 'N/A';
      return this.value;
    },
    isPositive() {
      return ['Y', 'Yes', 'Carrier', 'Interstate', 'None'].includes(this.valueDisplay);
    }
  }
}
</script>

<style scoped>
.checklist-item {
  line-height: 1.2;
}
</style>
